// extracted by mini-css-extract-plugin
module.exports = {"emailsContainer":"BorrowerEmails_emailsContainer__2zt01","noEmailsDescriptionContainer":"BorrowerEmails_noEmailsDescriptionContainer__3uz27"};